<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <!-- 分类列表 -->
          <p style="text-align: left; border-bottom: solid 3px #033d80; margin-bottom: 40px; "><span style="font-size: 22px; color: #505050;">Technological Breakthroughs</span></p>

          <!-- 新闻列表 -->
          <div class="b-newsList clearfix">
            <ul class="clearfix">
              <li v-for="item in sliceNewsList"
                  :key="item">
                <a :href="'/detail/en?type=achievements&id='+item.achievementsId" target="_blank"
                   class="b-item-link">
                  <div class="b-img">
                    <img :src="item.IP_URL + '/ueditor/images/zoomin_'+item.picture"
                         alt="img" height="262px">
<!--                    <div class="b-date">{{ item.publish_time }}</div>-->
                  </div>
                  <div class="b-item-name">{{ item.title }}</div>
<!--                  <div class="b-item-des">{{ item.description }}</div>-->
                </a>
              </li>
            </ul>
          </div>
          <el-pagination background
                         @current-change="handleCurrentChange"
                         layout="prev, pager, next"
                         :page-size="6"
                         :total="count">
          </el-pagination>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
import $ from "jquery";
export default {
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.sliceNewsList = this.newsList.slice((this.currentPage-1) * this.pageSize, this.currentPage * this.pageSize);
      console.log(`当前页: ${val}`);
    }
  },

  data () {
    return {
      pageSize: 6,
      newsList: [],
      count:0,
      sliceNewsList: [],
      categoryList: [],
    };
  },
  mounted () {
    // 分类
    this.categoryList = [

    ]
    // 新闻列表
    //为了在内部函数能使用外部函数的this对象，要给它赋值了一个名叫self的变量。
    var self = this;
    $.ajax({
      url:  Header.IP_URL + '/achievements/simpleList?scienceRecommend=1&l=en',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.newsList = res.data;
      self.count = res.count;
      self.sliceNewsList = self.newsList.slice(0, self.pageSize);
      for(var i=0;i < self.newsList.length; i++){
        if(self.newsList[i].picture == null || self.newsList[i].picture =="") {
          self.newsList[i].picture = "default_new_pic.jpg";
        }
        self.newsList[i].IP_URL = Header.IP_URL;
      }
    }).fail(function () {
      console.log('失败');
    });
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
.b-banner-con{
  //padding: 22px 0;
  background: url(../../../assets/img/banner_bg.png) no-repeat!important;
  background-size: cover!important;
  .b-header{
    margin-bottom: 0px;
  }
}
//分类列表
.b-category {
  display: flex;
  align-items: center;
  border: 1px solid #f4f4f4;
  padding: 10px;
  margin-bottom: 20px;
  .b-title {
    color: #838383;
    font-size: 14px;
    font-weight: normal;
    font-family: microsoft yahei;
    text-decoration: none;
  }
  .b-categoryList {
    ul {
      display: flex;
      align-items: center;
      .b-cate a{
        color: #333;
        font-size: 14px;
        font-family: microsoft yahei;
        padding: 2px 6px;
        margin: 0 10px;
        &:hover {
          color: #fff;
          background-color: #37617f;
        }
      }
    }
  }
}
/* 新闻列表 */
.b-newsList ul {
  margin: 0 -10px;
  //height: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  li {
    width: (100% / 3);
    float:left;
    margin: 0 0 15px 0;
    .b-item-link {
      margin: 0 8px;
      display: block;
      height: 375px;
      overflow: hidden;
    }
    .b-img {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      position: relative;
      img {
        width: 100%;
        height: 262px;
      }
      .b-date {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 40%;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        -dm-stylegroup: on;
        background-color: rgba(55, 97, 127, 0.6);
        color: #fff;
        font-family: microsoft yahei;
        font-size: 12px;
        line-height: 35px;
        text-align: right;
        padding-right: 10px;
        &:hover {
          width: 100%;
          background-color: rgb(55, 97, 127);
        }
      }
    }
    .b-item-name {
      text-align: left;
      color: rgb(102, 102, 102);
      font-size: 14px;
      /* font-weight: bold; */
      height: 25px;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      margin: 10px 0;
      &:hover {
        color: #2ba8e2;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .b-item-des {
      text-align: left;
      color: #666;
      font-size: 12px;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/achievements/en/index.vue